export var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["VIPPS"] = "VIPPS";
    PaymentMethodType["CREDIT_CARD"] = "CREDIT_CARD";
    PaymentMethodType["DINTERO"] = "DINTERO";
    PaymentMethodType["B2B_INVOICE"] = "B2B_INVOICE";
})(PaymentMethodType || (PaymentMethodType = {}));
